module.exports = __webpack_public_path__ + "static/media/nimes_porteauguste_tn.ca6bf022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_porteauguste_tn.jpg
// module id = 734
// module chunks = 0